module.exports = __webpack_public_path__ + "images/speed-seven-default.c4264f6f73ea09a4afb5d231c9898fbb.png";